import Phaser from "phaser";
import { TargetRing } from "../entities/TargetRing";
import { StageConfigEntry } from "../data/StageConfig";
import { randomRange } from "../utils/RNG";

export class TargetSystem {
  private scene: Phaser.Scene;
  private target: TargetRing | null = null;

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
  }

  createTarget(config: StageConfigEntry, gameW: number, gameH: number): TargetRing {
    if (this.target) {
      this.target.destroy();
    }
    const radius = randomRange(config.radiusPxMin, config.radiusPxMax);
    const margin = radius + 20;
    const tx = randomRange(margin, gameW - margin);
    const ty = randomRange(margin + 50, gameH - margin);
    this.target = new TargetRing(this.scene, tx, ty, radius);

    if (config.targetMove === "linear" && config.targetSpeedPxPerSec > 0) {
      this.target.setLinearMotion(config.targetSpeedPxPerSec);
    }

    return this.target;
  }

  getTarget(): TargetRing | null {
    return this.target;
  }

  update(dt: number): void {
    this.target?.update(dt);
  }

  destroy(): void {
    this.target?.destroy();
    this.target = null;
  }
}
